import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { Redirect, Route, Switch } from "wouter";
import { CompanyView } from "./company.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function CompanyRoutes() {
  const ability = useAbility();
  const companyUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const canManage = ability.can(Action.Manage, "Company");

  return (
    <Switch>
      <Route path={"/"} component={CompanyView} />
      <Route path={"/create"} component={canManage ? CreateView : ReadOnlyRedirect} />
      <Route path={companyUuidRegex} component={canManage ? UpdateView : ReadOnlyRedirect} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function ReadOnlyRedirect() {
  return <Redirect to="/" replace />;
}
